<template lang="pug">
	.card-parent(v-if="showed")
		.card
			.card-header Campaign
			.card-body
				.card-row
					.row-name Campaign id
					.row-propety {{campaign.id}}
				.card-row
					.row-name Campaign Name
					.row-propety {{campaign.name}}
				.card-row
					.row-name Order id
					.row-propety {{campaign.order_id}}
				.card-row
					.row-name Order name
					.row-propety {{orders[campaign.order_id].name}}
				.card-row
					.row-name Impression tag
					.rop_property(v-text="impTag")
				.card-row
					.row-name Click tag
					.rop_property {{this.metricTag.replace('${event_name}', 'click')}}
				.card-row
					.row-name Did Engage tag
					.rop_property {{this.metricTag.replace('${event_name}', 'did_engage')}}
				.card-row
					.row-name Game Complete tag
					.rop_property {{this.metricTag.replace('${event_name}', 'game_complete')}}
				.card-row
					.row-name Video Complete tag
					.rop_property {{this.metricTag.replace('${event_name}', 'video_complete')}}
				.card-row
					.row-name End Card Viewed tag
					.rop_property {{this.metricTag.replace('${event_name}', 'end_card_viewed')}}
				//.card-row
					.row-name Metric tag
					.rop_property {{this.metricTag}}


			.card-footer
				button.btn.btn-cancel(@click="hide") Close
				button.btn.btn-confirm(@click="copyCampaignData") Copy all

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";
import SetupSettings 	from "@/settings/settings.json";


export default {
	name: 'ShowCampaign',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {
		}
	},
	data() {

		this.Server = Server;

		return {
			campaign: {},
			orders: {},
			impTag: '',
			metricTag: ''
		}
	},
	methods: {
		collectData(action, campaign) {
			this.orders = Order.Orders;
			this.campaign = campaign;

			let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"];
			if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"];

			this.impTag =`<img src="${url}/api?order=${campaign.order_id}&campaign=${campaign.id}">`
			this.metricTag = `${url}/api?event=\${event_name}&order=${campaign.order_id}&campaign=${campaign.id}`;
		},
		copyCampaignData() {
			const textArea = document.createElement("textarea");

			textArea.value = `Campaign id: ${this.campaign.id}
Campaign name: ${this.campaign.name}
Order id: ${this.campaign.order_id}
Order name: ${this.orders[this.campaign.order_id].name}
Impression tag: ${this.impTag}
Click metric tag: ${this.metricTag.replace('${event_name}', 'click')}
Did Engage metric tag: ${this.metricTag.replace('${event_name}', 'did_engage')}
Game Complete metric tag: ${this.metricTag.replace('${event_name}', 'game_complete')}
Video Complete metric tag: ${this.metricTag.replace('${event_name}', 'video_complete')}
End Card Viewed metric tag: ${this.metricTag.replace('${event_name}', 'end_card_viewed')}`;

			document.body.appendChild(textArea);

			textArea.select();

			document.execCommand('copy');

			document.body.removeChild(textArea);
		}
	}
}

</script>

<style lang="sass">

	.card
		width: 800px

		>.card-footer
			display: flex
			flex-direction: row
			justify-content: space-between

			>.btn-cancel
				background-color: #2f353a
				color: white

		>.card-body
			display: flex
			flex-direction: column
			gap: 0.5em

			>.card-row
				display: flex
				flex-direction: row
				gap: 15px

				>.row-name
					width: 200px

				>.row-property
					flex: 1

</style>
